import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, CircularProgress, Button
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import { useGenerateQrCode } from './vanuser.hooks';

function QrcodeGenerate({ orderid, open, onClose }) {
  const dispatch = useDispatch();

  const {
    data: qrSrc,
    isLoading,
    isError,
    error
  } = useGenerateQrCode(orderid, open, {
    onError: (err) =>
      dispatch(showAlert({
        severity: 'error',
        title: err.message || 'Failed to load QR code.'
      })),
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Order #{orderid} QR Code</DialogTitle>

      <DialogContent dividers>
        {isLoading ? (
          <CircularProgress />
        ) : !qrSrc ? (
          <Typography>No QR code available.</Typography>
        ) : (
          <div style={{ textAlign: 'center', margin: '20px 0' }}>         
          <img
            src={qrSrc}
            alt={`QR Code for Order ${orderid}`}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
           <Typography variant="body1" gutterBottom>
            Scan the QR code below to view or download the bill for Order #{orderid}.
          </Typography>          
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant='contained'>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default QrcodeGenerate;
